import { MainForm } from './MainForm';
import { GuestInfoForm } from './GuestInfoForm';
import { SeatingSuccess } from './SeatingSuccess';
import { connect, ConnectedProps } from 'react-redux';
import { AppState, store, SeatingOperations } from '@maverick/cms';
import { SeatingData } from '@maverick/entity';

const mapStateToProps = (state: AppState) => ({
	seatingData: state.seating.seatingDataModify ?? state.seating.seatingData!,
});
const mapDispatchToProps = {
	setSeatingData: (seatingData: SeatingData | null) => {
		if (store.getState().seating.seatingDataModify) {
			return SeatingOperations.setSeatingDataModify(seatingData);
		}
		return SeatingOperations.setSeatingData(seatingData);
	},
	resetSeatingDataModify: SeatingOperations.resetSeatingDataModify,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type SeatingStepsReduxProps = ConnectedProps<typeof connector>;

const MainFormConnected = connector(MainForm);
export { MainFormConnected as MainForm };

const GuestInfoFormConnected = connector(GuestInfoForm);
export { GuestInfoFormConnected as GuestInfoForm };

const SeatingSuccessConnected = connector(SeatingSuccess);
export { SeatingSuccessConnected as SeatingSuccess };
